import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';

import { geoFromIP } from 'utils/bolt/geo';
import { isInEU } from 'utils/eu';
import { getCopy } from 'utils/copy';

import HTML from 'components/core/html/html.js';

import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
		const geo = await geoFromIP();
		const userInEU = await isInEU(geo?.countryCode);
		this.setState({ userCountry: geo?.countryCode, userInEU });
	}

	renderDoNotSellLogo() {
		const imageRoot = this.props.store?.appData?.urls?.roots?.sharedImages || '';
		return <img class={s.doNotSellLogo} src={imageRoot + '/Your_Privacy_Choices.png'} alt="Your privacy choices logo" />;
	}

	getLinkContent(link, type) {
		if (type === 'logo') {
			return super.getLinkContent(link, type);
		}
		let copy = link.$copy;
		if (link.copyUS && this.state.userCountry === 'us') {
			copy = link.copyUS;
		}
		let content = getCopy(copy, {}, '', null, 'baseCopy') || copy;
		if (type === 'copyright' || type === 'link') {
			content = <HTML content={content} markdown />;
		}
		return [
			link.showPrivacyChoicesLogo && this.state.userCountry === 'us' && this.renderDoNotSellLogo(),
			content,
		].filter(e => e);
	}

	renderLinks(items, type) {
		const { userInEU } = this.state;
		if (!userInEU) {
			items = Object.fromEntries(Object.entries(items || {}).filter(([key]) => key !== 'cookies'));
		}

		return super.renderLinks(items, type);
	}
}